import React, { Component, Fragment } from "react";
import { ai } from "./TelemetryService";
import { withRouter } from "react-router-dom";

export class TelemetryProvider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isInitialized: false
    };
  }

  initialiseAppInsights = () => {
    const { history, instrumentationKey } = this.props;
    if (instrumentationKey && history) {
      ai.initialize(instrumentationKey, history);
    }
  };

  componentDidMount() {
    if (!this.state.isInitialized) {
      this.setState({ isInitialized: true }, () => {
        this.initialiseAppInsights();
      });
    }
  }

  render() {
    return <Fragment>{this.props.children}</Fragment>;
  }
}

export default withRouter(TelemetryProvider);
